import { useState } from 'react';
import CodeBlock from './CodeBlock';
import { defaultExample, streamingExample, imageExample, functionsExample, logprobsExample } from './examples';

const tabs = [
  { id: 'default', label: 'Default' },
  { id: 'image', label: 'Image input' },
  { id: 'streaming', label: 'Streaming' },
  { id: 'functions', label: 'Functions' },
  { id: 'logprobs', label: 'Logprobs' }
];

const languages = [
  { id: 'python', label: 'OpenAI SDK' },
  { id: 'python_requests', label: 'Python Requests' },
  { id: 'javascript', label: 'Node.js' },
  { id: 'curl', label: 'cURL' }
];

export default function CodeTabs() {
  const [activeTab, setActiveTab] = useState('default');
  const [language, setLanguage] = useState('python');

  const getExampleCode = () => {
    const examples = {
      default: defaultExample,
      image: imageExample,
      streaming: streamingExample,
      functions: functionsExample,
      logprobs: logprobsExample
    };
    return examples[activeTab as keyof typeof examples][language as keyof typeof defaultExample];
  };

  return (
    <div className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white sm:text-4xl">
            Simple Integration
          </h2>
          <p className="mt-4 text-lg text-gray-300">
            Get started in minutes with our easy-to-use API
          </p>
        </div>

        <div className="bg-gray-800 rounded-xl overflow-hidden shadow-xl">
          <div className="p-4 border-b border-gray-700">
            <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
              <div className="flex rounded-lg bg-gray-900 p-1">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                      activeTab === tab.id
                        ? 'bg-blue-600 text-white'
                        : 'text-gray-400 hover:text-white'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <div className="flex items-center justify-between sm:justify-end sm:flex-1">
                <div className="flex flex-wrap gap-2">
                  {languages.map((lang) => (
                    <button
                      key={lang.id}
                      onClick={() => setLanguage(lang.id)}
                      className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                        language === lang.id
                          ? 'bg-blue-600 text-white'
                          : 'text-gray-400 hover:text-white'
                      }`}
                    >
                      {lang.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="p-6">
            <CodeBlock code={getExampleCode()} language={language} />
          </div>
        </div>
      </div>
    </div>
  );
}